export default __webpack_public_path__ + "img/apple-icon-180x180.png";